import { securityAPI } from '@/utils/api'

export async function maskMessage(content) {
  const result = await securityAPI.processMasking(content);
  return {
    masked: result.result || content,
    maskedText: result.data?.data?.maskedText,
    detectedPii: result.data?.data?.detectedPii || []
  };
} 